export interface SupportLanguage {
  code: string;
  nameVi: string;
  nameEn: string;
}

export const SUPPORT_LANGUAGES: readonly SupportLanguage[] = [
  { code: 'vi', nameVi: 'Tiếng Việt',          nameEn: 'Vietnamese' },
  { code: 'en', nameVi: 'Tiếng Anh',           nameEn: 'English' },
  { code: 'fr', nameVi: 'Tiếng Pháp',          nameEn: 'French' },
  { code: 'de', nameVi: 'Tiếng Đức',           nameEn: 'German' },
  { code: 'nl', nameVi: 'Tiếng Hà Lan',        nameEn: 'Dutch' },
  { code: 'es', nameVi: 'Tiếng Tây Ban Nha',   nameEn: 'Spanish' },
  { code: 'pt', nameVi: 'Tiếng Bồ Đào Nha',    nameEn: 'Portuguese' },
  { code: 'it', nameVi: 'Tiếng Ý',             nameEn: 'Italian' },
  { code: 'cs', nameVi: 'Tiếng Séc',           nameEn: 'Czech' },
  { code: 'sk', nameVi: 'Tiếng Slovak',        nameEn: 'Slovak' },
  { code: 'pl', nameVi: 'Tiếng Ba Lan',        nameEn: 'Polish' },
  { code: 'hu', nameVi: 'Tiếng Hungary',       nameEn: 'Hungarian' },
  { code: 'ru', nameVi: 'Tiếng Nga',           nameEn: 'Russian' },
  { code: 'sv', nameVi: 'Tiếng Thụy Điển',     nameEn: 'Swedish' },
  { code: 'no', nameVi: 'Tiếng Na Uy',         nameEn: 'Norwegian' },
  { code: 'da', nameVi: 'Tiếng Đan Mạch',      nameEn: 'Danish' },
  { code: 'fi', nameVi: 'Tiếng Phần Lan',      nameEn: 'Finnish' },
  { code: 'zh', nameVi: 'Tiếng Trung',         nameEn: 'Chinese' },
  { code: 'ja', nameVi: 'Tiếng Nhật',          nameEn: 'Japanese' },
  { code: 'ko', nameVi: 'Tiếng Hàn',           nameEn: 'Korean' },
];

export function getLanguageByCode(code: string): SupportLanguage | undefined {
  return SUPPORT_LANGUAGES.find((l) => l.code === code);
}

export function languageName(language: SupportLanguage, locale: 'vi' | 'en'): string {
  return locale === 'en' ? language.nameEn : language.nameVi;
}
